import React from 'react';
/**
 * @ignore - internal component.
 */

var ListContext = React.createContext({});
export default ListContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/List/ListContext.js
// module id = 249
// module chunks = 0